import resources from './resources';
const lng = localStorage.getItem('lng')
export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: (lng!==null&&lng!==undefined)?lng:'en',
  resources,
};

export { resources };
